window.addEventListener('DOMContentLoaded', () => {
    let newsSliderInit = false;

    function swiperNews() {
        if (window.innerWidth > 733) {
            if (!newsSliderInit) {
                newsSliderInit = true;
                swiper = new Swiper('.news__container', {
                    spaceBetween: 48,
                    breakpoints: {
                        733: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        1222: {
                            slidesPerView: 3,
                            spaceBetween: 48
                        },
                        1405: {
                            slidesPerView: 4,
                        }
                    },
                    keyboard: {
                        enabled: true,
                    }
                });
            }
        } else if (newsSliderInit) {
            swiper.destroy();
            newsSliderInit = false;
        }
    }
    swiperNews();
    window.addEventListener("resize", swiperNews);
});